const routes = [
  {
    path: '/toutiaoAd/:id',
    name: 'toutiaoAd',
    component: () => import('@views/Home/Home.vue')
  },
  {
    path: '/toutiaoNAd/:id',
    name: 'toutiaoNAd',
    component: () => import('@views/Advertise/ToutiaoAdvertise.vue')
  },
  {
    path: '/baiduAd/:id',
    name: 'baiduAd',
    component: () => import('@views/Home/Home.vue')
  },
  {
    path: '/baiduNAd/:id',
    name: 'baiduNAd',
    component: () => import('@views/Advertise/BaiduAdvertise.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@views/Home/Home.vue')
  },
  {
    path: '/rules',
    name: 'rules',
    component: () => import('@views/Rules/Rules.vue')
  },
  {
    path: '/submitSuccess',
    name: 'submitSuccess',
    component: () => import('@views/SubmitSuccess/SubmitSuccess.vue')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('@views/Result/Result.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@views/Login/Login.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('@views/Report/Report.vue')
  },
];

export default routes;
